<template>
  <v-col
    cols="4"
    sm="2"
    lg="1"
    class="frame"
  >
    <v-card
      class="ma-0 align-end"
      style="border-radius:8px"
      flat
    >
      <v-img
        class="white--text top-image"
        :src="photoUrl"
        @click.stop="$emit('click', item.pid)"
      >
      </v-img>
      <div
        class="content-frame"
      >
        <div
          v-if="!isMyShots"
        >
          <img
            class="avatar"
            :src="item.userPhotoUrl"
          />
          <img
            class="person-icon"
            :src="personIcon"
          />
          <div
            class="nickname"
            v-html="item.nickname"
          ></div>
          <img
            class="place-icon"
            :src="placeIcon"
          />
          <div
            class="place-name"
            v-html="area"
          ></div>
          <div
            class="place-flag"
            v-html="flag"
          ></div>
          <img
            v-if="showLikeName"
            :src="likeIcon"
            class="like-icon"
          />
          <div
            v-if="showLikeName"
            class="like-name"
            v-html="item.likeName"
          ></div>
        </div>
        <div
          v-if="isMyShots"
          class="my-shots"
        >
          <img
            v-if="showLikeName"
            :src="likeIcon"
            class="like-icon"
          />
          <div
            v-if="showLikeName"
            class="like-name"
            v-html="item.likeName"
          ></div>
          <img
            :src="heartIcon"
            class="heart-icon"
          />
          <div
            class="star-count"
            v-html="item.starCount"
          ></div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
import service from '@/plugins/service'

export default {
  props: {
    item: { type: Object, required: true },
    showLikeName: { type: Boolean, required: false, default: true, },
    isMyShots: { type: Boolean, required: false, default: false, },
  },
  data: () => ({
    personIcon: require('@/assets/images/likes/person.svg'),
    placeIcon: require('@/assets/images/likes/place.svg'),
    heartIcon: require('@/assets/images/likes/heart.svg'),
  }),
  computed: {
    area() {
      const region = this.item.wherLiveRegion.replace(/prefecture/i, '')
      return region
    },
    likeIcon() {
      return service.getLikeGroupIcon(this.item.likeGroupCode)
    },
    flag() {
      return service.getFlagCode(this.item.whereLiveCountryCode)
    },
    photoUrl() {
      if (this.item.photoUrl.startsWith("/")) {
        const prot = location.protocol
        const server = location.host
        return `${prot}//${server}${this.item.photoUrl}`
      } else {
        return this.item.photoUrl;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.frame
  padding 1px

.top-image
  border-radius 8px
  cursor pointer

.content-frame
  position relative
  background-color #FFFFFF
  margin 0 0 16px 0
  min-height 58px
  img.avatar
    position absolute
    top 4px
    left 0
    width 24px
    height 24px
    border-radius 12px
  img.person-icon
    position absolute
    top 4px
    left 28px
    width 16px
    height 16px
  div.nickname
    position absolute
    top 4px
    left 48px
    width calc(100% - 44px)
    font-style normal
    font-weight normal
    font-size 12px
    line-height 16px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  img.place-icon
    position absolute
    top 24px
    left 28px
    width 16px
    height 16px
  div.place-name
    position absolute
    top 24px
    left 48px
    width calc(100% - 44px - 17px)
    font-style normal
    font-weight normal
    font-size 12px
    line-height 16px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  div.place-flag
    position absolute
    top 24px
    right 0
    width 17px
    font-style normal
    font-weight normal
    font-size 12px
    line-height 16px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  img.like-icon
    position absolute
    top 44px
    left 28px
    width 16px
    height 16px
  div.like-name
    position absolute
    top 44px
    left 48px
    width calc(100% - 44px)
    font-style normal
    font-weight normal
    font-size 12px
    line-height 16px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  div.my-shots
    img.like-icon
      position absolute
      top 4px
      left 0
      width 16px
    div.like-name
      position absolute
      top 4px
      left 20px
      width calc(100% - 20px)
      font-style normal
      font-weight normal
      font-size 12px
      line-height 16px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    img.heart-icon
      position absolute
      top 24px
      left 0
      width 16px
      height 16px
    div.star-count
      position absolute
      top 24px
      left 20px
      width calc(100% - 20px)
      font-style normal
      font-weight normal
      font-size 12px
      line-height 16px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
</style>
